<template>
  <div>
    <h1>Login</h1>
    <div class="login">
      <form @submit.prevent="login">
        <label for="email">Email</label>
        <input v-model="email" type="text" name="email" value />
        <label for="password">Password</label>
        <input v-model="password" type="password" name="password" value />
        <button class="ui-button" type="submit">Login</button>
      </form>
      <div>
        <router-link to="register">Don't have an account? Register.</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Service from '@/services/Service.js';
export default {
  data: function() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    login() {
      Service.login(this.email, this.password)
        .then(response => {
          this.$store.dispatch('login', response.data).then(() => {
            this.$router.push({
              name: 'show-list'
            });
            this.email = '';
            this.password = '';
          });
        })
        .catch(error => {
          if (
            error.response.data.exceptionType ==
            'Monad.Data.UserValidationException'
          ) {
            this.$store.dispatch('addMessage', {
              message: 'Invalid login. Please try again'
            });
          }
          console.log(error);
        });
    }
  }
};
</script>
